import React from 'react';

import Dimmer from 'ui/dimmer/Dimmer';
import Loader from 'ui/loader/Loader';

import TableBody from './TableBody';
import TableCell from './TableCell';
import TableFooter from './TableFooter';
import TableHead from './TableHead';
import TableHeadCell from './TableHeadCell';
import TableRow from './TableRow';

type Props = {
  id?: string;
  basic?: boolean;
  fixed?: boolean;
  loading?: boolean;
  children: React.ReactNode;
  tableContainerClassNames?: (clss: string[]) => string[];
  scrollContainerClassNames?: (clss: string[]) => string[];
};

function Table({
  id,
  basic = false,
  fixed = false,
  loading = false,
  tableContainerClassNames = (clss: string[]) => clss,
  scrollContainerClassNames = (clss: string[]) => clss,
  children,
}: Props) {
  const tableContainerClasses = ['mx-1', 'relative'];
  const tableClasses = ['min-w-full', 'divide-y', 'divide-gray-200', 'table-auto'];

  if (fixed) {
    tableClasses.push('table-fixed');
  } else {
    tableClasses.push('table-auto');
  }

  if (!basic) {
    tableContainerClasses.push('shadow', 'overflow-hidden', 'rounded-lg', 'bg-white');
  }

  return (
    <div id={id} className="flex flex-col">
      <div className={scrollContainerClassNames(['-my-2', '-mx-1', 'overflow-x-auto']).join(' ')}>
        <div className="inline-block min-w-full py-2 align-middle">
          <div className={tableContainerClassNames(tableContainerClasses).join(' ')}>
            <Dimmer open={loading}>
              <Loader />
            </Dimmer>

            <table className={tableClasses.join(' ')}>{children}</table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Object.assign(Table, {
  Header: TableHead,
  HeaderCell: TableHeadCell,
  Cell: TableCell,
  Row: TableRow,
  Body: TableBody,
  Footer: TableFooter,
});
